import React, { Fragment, ReactNode, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function Modal({
  title,
  show,
  hide,
  panelClassName = "",
  bodyWrapperClassName = "",
  children,
}: {
  title: string;
  show: boolean;
  hide: () => void;
  panelClassName?: string;
  bodyWrapperClassName?: string;
  children: ReactNode;
}) {
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="z-50 relative" initialFocus={cancelButtonRef} onClose={hide}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="z-40 fixed inset-0 overflow-y-auto">
          <div className="flex justify-center items-center min-h-full p-4 sm:p-0 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative sm:w-full sm:max-w-lg overflow-hidden sm:my-8 rounded-lg bg-white shadow-xl text-left transition-all transform ${panelClassName}`}
              >
                <div className="flex justify-between px-4 sm:px-6 py-3 bg-gray-50">
                  <Dialog.Title as="h3" className="font-medium text-gray-900 text-lg leading-6">
                    {title}
                  </Dialog.Title>
                  <button
                    type="button"
                    onClick={() => {
                      hide();
                    }}
                  >
                    <XMarkIcon className="block w-8 h-8" aria-hidden="true" />{" "}
                  </button>
                </div>
                <div className={`sm:p-6 px-4 pt-5 pb-4 sm:pb-4 bg-white ${bodyWrapperClassName}`}>
                  <div className="overflow-auto">{children}</div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
